import { createAction, props } from '@ngrx/store';

export const connectToCoreHub = createAction('[HUB CONNECTION SERVICE] Connect to Core hub');
export const connectToCoreHubSuccess = createAction('[HUB CONNECTION SERVICE] Connect to Core hub Success');
export const connectToCoreHubFailure = createAction(
    '[HUB CONNECTION SERVICE] Connect to Core hub Failure',
    props<{ error: unknown }>()
);
export const disconnectFromCoreHub = createAction('[HUB CONNECTION SERVICE] Disconnect from Core hub');
export const disconnectFromCoreHubSuccess = createAction('[HUB CONNECTION SERVICE] Disconnect from Core hub Success');
export const disconnectFromCoreHubFailure = createAction(
    '[HUB CONNECTION SERVICE] Disconnect from Core hub Failure',
    props<{ error: unknown }>()
);
export const isHubConnectionActive = createAction(
    '[HUB CONNECTION SERVICE] Is hub connection active',
    props<{ isActive: boolean }>()
);

export const connectToPdHub = createAction(
    '[HUB CONNECTION SERVICE] Connect to PD hub',
    props<{ facilityId: number; facilitySystemId: number }>()
);

export const connectToPdHubSuccess = createAction('[HUB CONNECTION SERVICE] Connect to PD hub Success');
export const connectToPdHubFailure = createAction(
    '[HUB CONNECTION SERVICE] Connect to PD hub Failure',
    props<{ error: unknown }>()
);
export const disconnectFromPdHub = createAction('[HUB CONNECTION SERVICE] Disconnect from PD hub');
export const disconnectFromPdHubSuccess = createAction('[HUB CONNECTION SERVICE] Disconnect from PD hub Success');
export const disconnectFromPdHubFailure = createAction(
    '[HUB CONNECTION SERVICE] Disconnect from PD hub Failure',
    props<{ error: unknown }>()
);
export const isPdHubConnectionActive = createAction(
    '[HUB CONNECTION SERVICE] Is PD hub connection active',
    props<{ isActive: boolean }>()
);
export const connectToTimecardHub = createAction('[HUB CONNECTION SERVICE] Connect to Timecard hub');
export const connectToTimecardHubSuccess = createAction('[HUB CONNECTION SERVICE] Connect to Timecard hub Success');
export const connectToTimecardHubFailure = createAction(
    '[HUB CONNECTION SERVICE] Connect to Timecard hub Failure',
    props<{ error: unknown }>()
);
export const disconnectFromTimecardHub = createAction('[HUB CONNECTION SERVICE] Disconnect from Timecard hub');
export const disconnectFromTimecardHubSuccess = createAction(
    '[HUB CONNECTION SERVICE] Disconnect from Timecard hub Success'
);
export const disconnectFromTimecardHubFailure = createAction(
    '[HUB CONNECTION SERVICE] Disconnect from Timecard hub Failure',
    props<{ error: unknown }>()
);
export const isTimecardHubConnectionActive = createAction(
    '[HUB CONNECTION SERVICE] Is Timecard hub connection active',
    props<{ isActive: boolean }>()
);

export const connectToInvoiceHub = createAction('[HUB CONNECTION SERVICE] Connect to Invoice hub');
export const connectToInvoiceHubSuccess = createAction('[HUB CONNECTION SERVICE] Connect to Invoice hub Success');
export const connectToInvoiceHubFailure = createAction(
    '[HUB CONNECTION SERVICE] Connect to Invoice hub Failure',
    props<{ error: unknown }>()
);
export const disconnectFromInvoiceHub = createAction('[HUB CONNECTION SERVICE] Disconnect from Invoice hub');
export const disconnectFromInvoiceHubSuccess = createAction(
    '[HUB CONNECTION SERVICE] Disconnect from Invoice hub Success'
);
export const disconnectFromInvoiceHubFailure = createAction(
    '[HUB CONNECTION SERVICE] Disconnect from Invoice hub Failure',
    props<{ error: unknown }>()
);
export const isInvoiceHubConnectionActive = createAction(
    '[HUB CONNECTION SERVICE] Is Invoice hub connection active',
    props<{ isActive: boolean }>()
);

export const connectToReverseInvoiceHub = createAction('[HUB CONNECTION SERVICE] Connect to Reverse Invoice hub');
export const connectToReverseInvoiceHubSuccess = createAction(
    '[HUB CONNECTION SERVICE] Connect to Reverse Invoice hub Success'
);
export const connectToReverseInvoiceHubFailure = createAction(
    '[HUB CONNECTION SERVICE] Connect to ReverseInvoice hub Failure',
    props<{ error: unknown }>()
);
export const disconnectFromReverseInvoiceHub = createAction(
    '[HUB CONNECTION SERVICE] Disconnect from Reverse Invoice hub'
);
export const disconnectFromReverseInvoiceHubSuccess = createAction(
    '[HUB CONNECTION SERVICE] Disconnect from ReverseInvoice hub Success'
);
export const disconnectFromReverseInvoiceHubFailure = createAction(
    '[HUB CONNECTION SERVICE] Disconnect from ReverseInvoice hub Failure',
    props<{ error: unknown }>()
);
export const isReverseInvoiceHubConnectionActive = createAction(
    '[HUB CONNECTION SERVICE] Is ReverseInvoice hub connection active',
    props<{ isActive: boolean }>()
);

export const connectToComplianceHub = createAction(
    '[HUB CONNECTION SERVICE] Connect to Compliance hub',
    props<{ contractId: number }>()
);
export const connectToComplianceHubSuccess = createAction('[HUB CONNECTION SERVICE] Connect to Compliance hub Success');
export const connectToComplianceHubFailure = createAction(
    '[HUB CONNECTION SERVICE] Connect to Compliance hub Failure',
    props<{ error: unknown }>()
);
export const disconnectFromComplianceHub = createAction('[HUB CONNECTION SERVICE] Disconnect from Compliance hub');
export const disconnectFromComplianceHubSuccess = createAction(
    '[HUB CONNECTION SERVICE] Disconnect from Compliance hub Success'
);
export const disconnectFromComplianceHubFailure = createAction(
    '[HUB CONNECTION SERVICE] Disconnect from Compliance hub Failure',
    props<{ error: unknown }>()
);
export const isComplianceHubConnectionActive = createAction(
    '[HUB CONNECTION SERVICE] Is Compliance hub connection active',
    props<{ isActive: boolean }>()
);

export const connectToDocumentTypeBulkACStatusChangeNotifierHub = createAction(
    '[HUB CONNECTION SERVICE] Connect to Document Type Bulk AC Status Change Notifier hub'
);
export const connectToDocumentTypeBulkACStatusChangeNotifierHubSuccess = createAction(
    '[HUB CONNECTION SERVICE] Connect to Document Type Bulk AC Status Change Notifier hub Success'
);
export const connectToDocumentTypeBulkACStatusChangeNotifierHubFailure = createAction(
    '[HUB CONNECTION SERVICE] Connect to Document Type Bulk AC Status Change Notifier hub Failure',
    props<{ error: unknown }>()
);
export const disconnectFromDocumentTypeBulkACStatusChangeNotifierHub = createAction(
    '[HUB CONNECTION SERVICE] Disconnect from Document Type Bulk AC Status Change Notifier hub'
);
export const disconnectFromDocumentTypeBulkACStatusChangeNotifierHubSuccess = createAction(
    '[HUB CONNECTION SERVICE] Disconnect from Document Type Bulk AC Status Change Notifier hub Success'
);
export const disconnectFromDocumentTypeBulkACStatusChangeNotifierHubFailure = createAction(
    '[HUB CONNECTION SERVICE] Disconnect from Document Type Bulk AC Status Change Notifier hub Failure',
    props<{ error: unknown }>()
);
export const isDocumentTypeBulkACStatusChangeNotifierHubConnectionActive = createAction(
    '[HUB CONNECTION SERVICE] Is Document Type Bulk AC Status Change Notifier hub connection active',
    props<{ isActive: boolean }>()
);
